export default __webpack_public_path__ + "static/media/infobanner2.984daba6.svg";